<script setup lang="ts">
import { computed } from 'vue';
import { EMIT } from '@/enum';

interface PropsInterface {
  organizationNames: string[];
  caseManagerName: string;
}

const props = defineProps<PropsInterface>();
const emit = defineEmits<{
  (e: EMIT.CANCEL): void;
  (e: EMIT.ACCEPT): void;
}>();

const organizationList = computed(() => {
  const names = props.organizationNames;
  return names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names.at(-1)}` : names[0];
});

const affectedPhrase = computed(() =>
  props.organizationNames.length > 1 ? 'those organizations' : 'that organization',
);

const onCancel = () => emit(EMIT.CANCEL);
const onAccept = () => emit(EMIT.ACCEPT);
</script>

<template>
  <ConfirmAction
    header="Remove Organization"
    class="remove-organization-modal"
    :style="{ width: '30rem' }"
    accept-label="Remove Organization"
    accept-type="alert"
    @accept="onAccept"
    @cancel="onCancel"
  >
    <div class="flex">
      <Icon name="warning" class="confirm-dialog-icon text-gray-600" />
      <div class="ml-3">
        <p class="remove-notice mb-2">
          Removing
          <b>{{ organizationList }}</b>
          from
          <b>{{ caseManagerName }}</b>
          will also remove them from all students in {{ affectedPhrase }}.
        </p>
        <p class="remove-notice">This cannot be undone.</p>
      </div>
    </div>
  </ConfirmAction>
</template>

<style scoped lang="scss">
.remove-organization-modal {
  .remove-notice {
    color: $grayDark !important;
  }
}
</style>
